<template>
  <div id="grand-container" class="container">
    <div class="w-100 mt-1 mb-1">
      <router-link
        class="w-20"
        style="margin: 0px 100% 0px 0px"
        :to="
          this.$route.params.orderId
            ? { path: '/all-orders' }
            : { path: '/users' }
        "
      >
        <button class="btn btn-primary">Back</button>
      </router-link>
    </div>
    <div v-if="loading" class="loader">...loading</div>
    <div v-if="!loading && this.$route.params.orderId">
      <h1>User's Data</h1>
      <p class="user-col">User's Name: {{ userData.name }}</p>
      <p class="user-col">User's email: {{ userData.email }}</p>
      <p class="user-col">
        User's mobile: {{ userData.mobile ? userData.mobile : "Unkown" }}
      </p>
      <p class="user-col">
        User's address: {{ userData.address ? userData.address : "Unknown" }}
      </p>
      <p class="user-col">
        User's discount: {{ userData.discount ? userData.discount : "None" }}
      </p>
    </div>

    <router-link style="margin: 0px 100% 0px 0px" :to="{ path: '/users' }">
      <div class="alert alert-info w-100">
        To delete an order or edit its status or delivery method, click here.<br />
        You will need the user's email or mobile, and the order ID
      </div>
    </router-link>
    <div v-if="!loading && !this.$route.params.orderId" class="main">
      <div v-if="orders.length == 0" class="no-order">
        No orders for this user yet
      </div>
      <div class="orders">
        <div class="order">
          <p class="order__attribute">id</p>
          <p class="order__attribute">Ordering Date</p>
          <p class="order__attribute">Delivery Type</p>
          <p class="order__attribute">Delivery Date</p>
          <p class="order__attribute">Address</p>
          <p class="order__attribute">Status</p>
          <p class="order__attribute">User Discount %</p>
          <p class="order__attribute">Partner Discount %</p>
          <p class="order__attribute">Quantity Discount</p>
          <p class="order__attribute">Delivery Cost</p>
          <p class="order__attribute">Sizeman Cost</p>
          <p class="order__attribute">Total</p>
          <p class="order__attribute">Expected Total</p>
        </div>
        <div
          v-for="order in orders"
          :key="order.id"
          class="order--row"
          @click="handleSelectOrder(order)"
        >
          <p class="order__attribute">{{ order.id }}</p>
          <p class="order__attribute">
            {{ new Date(order.ordering_date).toLocaleString() }}
          </p>
          <p class="order__attribute">{{ order.delivery_type }}</p>
          <p class="order__attribute">
            {{
              order.delivery_date
                ? new Date(order.delivery_date).toLocaleString()
                : ""
            }}
          </p>
          <p class="order__attribute">{{ order.address }}</p>
          <p class="order__attribute">{{ getOrderStatusText(order.status) }}</p>
          <p class="order__attribute">{{ order.user_discount }}</p>
          <p class="order__attribute">{{ order.partner_discount }}</p>
          <p class="order__attribute">{{ order.quantity_discount }}</p>
          <p class="order__attribute">{{ order.delivery_cost }}</p>
          <p class="order__attribute">{{ order.size_man }}</p>
          <p class="order__attribute">{{ order.total }}</p>
          <p class="order__attribute">{{ order.expected_total }}</p>
        </div>
      </div>
    </div>
    <div class="nav-buttons" v-if="!loading && !this.$route.params.orderId">
      <button
        class="btn btn-success"
        v-show="pageIndex > 1"
        @click="handleClickPrevious"
      >
        Previous Page
      </button>
      <p>Page {{ pageIndex }}</p>
      <button
        class="btn btn-success"
        v-show="orders.length >= pageSize"
        @click="handleClickNext"
      >
        Next Page
      </button>
    </div>
    <div class="current-order" v-if="currentOrder">
      <div class="current-order__details">
        <div class="row">
          <div class="col-6">
            <h2>Order Details:</h2>
            <p>Order Id: {{ currentOrder.id }}</p>
            <p>Address: {{ currentOrder.address }}</p>
            <p>Delivery Method: {{ currentOrder.deliveryMethod }}</p>
          </div>
          <div class="col-6" v-if="currentOrder.delivery_address && currentOrder.delivery_address != null">
            <h2>Order Address Details:</h2>
            <p v-if="currentOrder.delivery_address.region">Region : {{ currentOrder.delivery_address.region }}</p>
            <p v-if="currentOrder.delivery_address.naighborhood">Naighborhood: {{ currentOrder.delivery_address.naighborhood }}</p>
            <p v-if="currentOrder.delivery_address.milestone">Neraby Milestone: {{ currentOrder.delivery_address.milestone }}</p>
            <p v-if="currentOrder.delivery_address.details">Details : {{ currentOrder.delivery_address.details }}</p>
            <p v-if="currentOrder.delivery_address.from">Suitable date: {{ `From: ${currentOrder.delivery_address.from} - To: ${currentOrder.delivery_address.to}` }}</p>

          </div>
        </div>
        
        <div class="row">
          <div class="col-md-4">
            <p>Order Status: {{ currentOrder.status }}</p>
          </div>
          <div class="col-md-12">
            <label
              class="bg-primary rounded"
              style="padding: 4px; margin: 5px; color: #fff"
              >Change Order Status</label
            >
            <b-form-select
              class="modified-dropdown form-control col-4"
              :options="orderStatuses"
              v-model="currentOrderStatus"
            >
            </b-form-select>
            <button
              type="button"
              class="btn btn-primary"
              @click="changeCurrentOrderStatus()"
            >
              Submit Changes
            </button>
          </div>
        </div>
      </div>

      <div class="current-order__products">
        <h3>Order Products:</h3>
        <div class="product__header">
          <p class="product__cell">Image</p>
          <p class="product__cell">SKU</p>
          <p class="product__cell">Title</p>
          <p class="product__cell">Title (en)</p>
          <p class="product__cell">Quantity</p>
          <p class="product__cell">Cost</p>
          <p class="product__cell">Profile</p>
          <p class="product__cell">Size</p>
          <p class="product__cell">Color</p>
          <p class="product__cell">Fabric</p>
        </div>
        <div
          :key="index"
          v-for="(product, index) in currentOrder.products"
          class="product__row"
          @click="handleSelectProduct(product)"
        >
          <!-- <p class="product__cell">{{product.orderProductId}}</p> -->
          <p class="product__cell">
            <img
              :src="product.image"
              :alt="product.title"
              width="50"
              height="50"
            />
          </p>
          <p class="product__cell">{{ product.sku }}</p>
          <p class="product__cell">{{ product.title }}</p>
          <p class="product__cell">{{ product.title_en }}</p>
          <p class="product__cell">{{ product.quantity }}</p>
          <p class="product__cell">{{ product.cost }}</p>
          <p class="product__cell">
            {{ product.profile ? product.profile.name : null }}
          </p>
          <p class="product__cell">
            <a
              v-if="
                product.stockQuantities && product.stockQuantities.size != null
              "
              style="
                display: inline-block;
                width: 35px;
                height: 35px;
                text-align: center;
              "
              class="p-1 border"
            >
              <span>{{ product.stockQuantities.size.name }}</span>
            </a>
          </p>
          <p class="product__cell">
            <a
              class="p-1 border"
              style="
                width: 35px;
                height: 35px;
                font-size: 0.8em;
                display: inline-block;
              "
            >
              <img
                v-if="
                  product.stockQuantities &&
                  product.stockQuantities.color != null
                "
                :src="product.stockQuantities.color.image"
                :alt="product.stockQuantities.color.name"
                width="100%"
                height="100%"
              />
              <img
                v-if="
                  product.stockQuantities &&
                  product.stockQuantities.shoeColor != null
                "
                :src="product.stockQuantities.shoeColor.image"
                :alt="product.stockQuantities.shoeColor.name"
                width="100%"
                height="100%"
              />
            </a>
          </p>
          <p class="product__cell">
            <a
              v-if="
                product.stockQuantities &&
                product.stockQuantities.fabric != null
              "
              style="
                display: inline-block;
                width: 50px;
                height: 35px;
                text-align: center;
              "
              class="p-1 border"
            >
              <span style="font-size: 0.8em">{{
                product.stockQuantities.fabric.name
              }}</span>
            </a>
          </p>
        </div>
      </div>
      <div class="current-product" v-if="currentProduct">
        <h3>Product Details:</h3>
        <!-- <p>Id: {{currentProduct.orderProductId}}</p> -->

        <div class="row">
          <div class="col-4">
            <img
              :src="currentProduct.image"
              :alt="currentProduct.title"
              height="250"
            />
          </div>
          <div class="col text-left">
            <p>Title: {{ currentProduct.title }}</p>
            <p>Quantity: {{ currentProduct.quantity }}</p>
            <p>SKU: {{ currentProduct.sku }}</p>
            <div class="current-product__sizes">
              <div class="current-product__sizes__update" v-if="sizesUpdate">
                <div v-if="!Number(currentProduct.size)">
                  <p>select size or profile</p>
                  <select class="form-control" v-model="measurementToUpdate">
                    <option :value="{ size: 'sizeman', type: 'static' }">
                      Sizeman
                    </option>
                    <option :value="{ size: 's', type: 'static' }">
                      small
                    </option>
                    <option :value="{ size: 'm', type: 'static' }">
                      medium
                    </option>
                    <option :value="{ size: 'l', type: 'static' }">
                      large
                    </option>
                    {{
                      (completeProfiles = profiles.filter((profile) => {
                        if (
                          profile.value_1 != null &&
                          profile.value_2 != null &&
                          profile.value_3 != null &&
                          profile.value_4 != null &&
                          profile.value_5 != null &&
                          profile.value_6 != null &&
                          profile.value_7 != null &&
                          profile.value_8 != null &&
                          profile.value_9 != null &&
                          profile.value_10 != null &&
                          profile.value_11 != null &&
                          profile.value_12 != null 
                        ) {
                          return profile;
                        }
                      }))
                    }}
                    {{ if(completeProfiles.length > 0) { return (
                    <option
                      :key="profile.id"
                      v-for="profile in completeProfiles"
                      :value="{ size: profile, type: 'profile' }"
                    >
                      {{ profile.name }}
                    </option>
                    ) } }}
                    <!-- <option :key="profile.id" v-for="profile in profiles" :value="{size: profile, type: 'profile'}">{{profile.name}}</option> -->
                    {{
                      (incompleteProfiles = profiles.filter((profile) => {
                        if (
                          profile.value_1 == null ||
                          profile.value_2 == null ||
                          profile.value_3 == null ||
                          profile.value_4 == null ||
                          profile.value_5 == null ||
                          profile.value_6 == null ||
                          profile.value_7 == null ||
                          profile.value_8 == null ||
                          profile.value_9 == null ||
                          profile.value_10 == null ||
                          profile.value_11 == null ||
                          profile.value_12 == null 
                        ) {
                          return profile;
                        }
                      }))
                    }}
                    {{ if(incompleteProfiles.length > 0) { return (
                    <option
                      :key="profile.id"
                      v-for="profile in incompleteProfiles"
                      :value="{ size: profile, type: 'profile' }"
                      disabled
                    >
                      {{ profile.name }} .... هذا الملف غير مكتمل
                    </option>
                    ) } }}
                  </select>
                </div>
                <div v-else>
                  <input
                    v-model="measurementToUpdate"
                    type="number"
                    min="35"
                    max="60"
                  />
                </div>
                <button class="btn btn-success" @click="applySizeUpdate">
                  Save updates
                </button>
                <p class="mt-2">سيتم إضافه رسوم إضافية فى حالة طلب الترزى</p>
              </div>
              <div class="current-product__sizes__view" v-else>
                <p>
                  Profile:
                  {{
                    currentProduct.profile ? currentProduct.profile.name : null
                  }}
                </p>
                <p>Size: {{ currentProduct.size }}</p>
                <button class="btn btn-primary" @click="toggleSizeUpdate">
                  Update measurement
                </button>
                <p
                  v-if="
                    currentProduct.size === 'Sizeman' ||
                    currentProduct.size === 'sizeman'
                  "
                  class="mt-2"
                >
                  سيتم إضافه رسوم إضافية فى حالة طلب الترزى
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="currentCustomizationData.status == true">
          <h1>Customization Data:</h1>

          <div
            v-if="
              currentCustomizationData.colors &&
              currentCustomizationData.colors.length
            "
          >
            <h1 style="margin: 20px">Color</h1>
            <div
              v-for="option in currentCustomizationData.colors"
              :key="option.image"
            >
              <div
                style="width: 200px; display: inline-block"
                v-if="
                  !currentCustomizationData.selectedColorId ||
                  currentCustomizationData.selectedColorId == option.id
                "
              >
                <img
                  style="width: 150px; height: 150px; display: inline-block"
                  :src="option.img"
                />
                <p>{{ option.name }}</p>
              </div>
            </div>
          </div>

          <div
            v-if="
              currentCustomizationData.customs &&
              currentCustomizationData.customs.length
            "
          >
            <div
              v-for="customCategory in currentCustomizationData.customs"
              :key="customCategory.title"
            >
              <h1 style="margin: 20px">{{ customCategory.title }}</h1>
              <div v-for="option in customCategory.images" :key="option.id">
                <div
                  style="width: 200px; display: inline-block"
                  v-if="
                    !currentCustomizationData.selectedIds ||
                    currentCustomizationData.selectedIds.find((i) => {
                      return option.id == i;
                    })
                  "
                >
                  <img
                    style="width: 150px; height: 150px; display: inline-block"
                    :src="option.imgPath"
                  />
                  <p>{{ option.name }}</p>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              currentCustomizationData.fabric_custom &&
              currentCustomizationData.fabric_custom.length
            "
          >
            <h1 style="margin: 20px">Custom fabrics</h1>
            <div
              v-for="option in currentCustomizationData.fabric_custom"
              :key="option.image"
            >
              <div
                style="width: 200px; display: inline-block"
                v-if="
                  !currentCustomizationData.selectedIds ||
                  currentCustomizationData.selectedIds.find((i) => {
                    return option.id == i;
                  })
                "
              >
                <img
                  style="width: 150px; height: 150px; display: inline-block"
                  :src="option.image"
                />
                <p>{{ option.name }}</p>
              </div>
            </div>
          </div>
          <div
            v-if="
              currentCustomizationData.yaka_custom &&
              currentCustomizationData.yaka_custom.length
            "
          >
            <h1 style="margin: 20px">Custom yakas</h1>
            <div
              v-for="option in currentCustomizationData.yaka_custom"
              :key="option.image"
            >
              <div
                style="width: 200px; display: inline-block"
                v-if="
                  !currentCustomizationData.selectedIds ||
                  currentCustomizationData.selectedIds.find((i) => {
                    return option.id == i;
                  })
                "
              >
                <img
                  style="width: 150px; height: 150px; display: inline-block"
                  :src="option.image"
                />
                <p>{{ option.name }}</p>
              </div>
            </div>
          </div>
          <div
            v-if="
              currentCustomizationData.zarzour_custom &&
              currentCustomizationData.zarzour_custom.length
            "
          >
            <h1 style="margin: 20px">Custom zarzours</h1>
            <div
              v-for="option in currentCustomizationData.zarzour_custom"
              :key="option.image"
            >
              <div
                style="width: 200px; display: inline-block"
                v-if="
                  !currentCustomizationData.selectedIds ||
                  currentCustomizationData.selectedIds.find((i) => {
                    return option.id == i;
                  })
                "
              >
                <img
                  style="width: 150px; height: 150px; display: inline-block"
                  :src="option.image"
                />
                <p>{{ option.name }}</p>
              </div>
            </div>
          </div>
          <div
            v-if="
              currentCustomizationData.akmam_custom &&
              currentCustomizationData.akmam_custom.length
            "
          >
            <h1 style="margin: 20px">Custom akmams</h1>
            <div
              v-for="option in currentCustomizationData.akmam_custom"
              :key="option.image"
            >
              <div
                style="width: 200px; display: inline-block"
                v-if="
                  !currentCustomizationData.selectedIds ||
                  currentCustomizationData.selectedIds.find((i) => {
                    return option.id == i;
                  })
                "
              >
                <img
                  style="width: 150px; height: 150px; display: inline-block"
                  :src="option.image"
                />
                <p>{{ option.name }}</p>
              </div>
            </div>
          </div>
          <div
            v-if="
              currentCustomizationData.others_custom &&
              currentCustomizationData.others_custom.length
            "
          >
            <h1 style="margin: 20px">Custom others</h1>
            <div
              v-for="option in currentCustomizationData.others_custom"
              :key="option.image"
            >
              <div
                style="width: 200px; display: inline-block"
                v-if="
                  !currentCustomizationData.selectedIds ||
                  currentCustomizationData.selectedIds.find((i) => {
                    return option.id == i;
                  })
                "
              >
                <img
                  style="width: 150px; height: 150px; display: inline-block"
                  :src="option.image"
                />
                <p>{{ option.name }}</p>
              </div>
            </div>
          </div>
          <!-- <div>
            <h1 style="margin:20px">Custom measurements</h1>
            <div style="width:200px;display:inline-block" v-for="option in currentCustomizationData.measurement_custom" :key="option.image">
                <img style="width:150px;height:150px;display:inline-block" :src="option.image">
            </div>
        </div> -->
        </div>
      </div>
    </div>
    <div class="current-order--empty" v-else>
      <p>No selected order yet</p>
    </div>
  </div>
</template>

<script>
// import { globalStore } from "../main.js";
import axios from "axios";
import { getCookie } from "../cookie";
import { herokuUrl } from "../apiConfig";
import logOut from "../scripts/utils";

export default {
  data() {
    return {
      orders: [],
      loading: false,
      error: null,
      selectedOrderId: null,
      currentOrder: null,
      currentProduct: null,
      sizesUpdate: false,
      measurementToUpdate: null,
      profiles: [],
      pageSize: 5,
      pageIndex: 1,
      userData: null,
      currentCustomizationData: null,
      currentOrderStatus: null,
      orderStatuses: [
        { value: "new", text: "New - جديد" },
        {
          value: "pending_payment",
          text: "Pending Payment - فى إنتظار الحوالة",
        },
        { value: "production", text: "Production - فى الإنتاج" },
        { value: "charged", text: "Charged - تم الشحن" },
        { value: "delivered", text: "Delivered - تم التسليم" },
        { value: "pickable", text: "Pickable - جاهز للإستلام" },
        { value: "cancelled", text: "Cancelled - تم الإلغاء" },
      ],
    };
  },
  watch: {
    currentProduct: function () {
      if (this.currentProduct) {
        this.fetchCustomizationData(this.currentProduct.orderProductId);
      }
    },
  },
  methods: {
    changeCurrentOrderStatus() {
      if (this.currentOrderStatus == null) {
        return;
      }
      if (
        confirm("Please confirm you want to update the selected Order's status")
      ) {
        {
          this.loading = true;
          return axios
            .put(
              `${herokuUrl}/dashboard/update-order-status`,
              {
                orderId: this.currentOrder.id,
                orderStatus: this.currentOrderStatus,
              },
              {
                headers: {
                  Authorization: getCookie("user"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                alert("Order was Edited successfully");
                // this.partiallyResetForm();
                this.handleSelectOrder({ id: this.currentOrder.id });
              } else {
                alert(
                  "There was a problem editing the selected Order " +
                    res.data.message
                );
              }
            })
            .catch((err) => {
              if (err.response.status == 401) {
                logOut();
              } else {
                this.loading = false;
                alert(
                  "There was a problem editing the selected Order " +
                    err.response.data.message
                );
              }
            });
        }
      }
    },
    fetchCustomizationData: function (a_orderProductRelId) {
      this.loading = true;
      axios
        .post(
          herokuUrl + "/dashboard/order-item-edits",
          {
            orderProductRelId: a_orderProductRelId,
          },
          {
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json",
            },
          }
        )
        .then((response) => {
          // console.log(response);
          this.currentCustomizationData = response.data;
          this.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.loading = false;
            this.error = err;
          }
        });
    },
    /* eslint-disable no-console */
    handleClickPrevious: function () {
      axios
        .post(
          herokuUrl + "/dashboard/getAllOrders",
          {
            userId: this.$route.params.id,
            pageSize: this.pageSize,
            pageIndex: this.pageIndex - 1,
          },
          {
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this.loading = false;
            this.orders = response.data.orders;
            this.pageIndex = this.pageIndex - 1;
          } else {
            this.loading = false;
            this.error = response.data.message;
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.loading = false;
            this.error = err;
          }
        });
    },
    handleClickNext: function () {
      axios
        .post(
          herokuUrl + "/dashboard/getAllOrders",
          {
            userId: this.$route.params.id,
            pageSize: this.pageSize,
            pageIndex: this.pageIndex + 1,
          },
          {
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this.loading = false;
            this.orders = response.data.orders;
            this.pageIndex = this.pageIndex + 1;
          } else {
            this.loading = false;
            this.error = response.data.message;
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.loading = false;
            this.error = err;
          }
        });
    },
    handleSelectOrder: function (order) {
      axios
        .post(
          herokuUrl + "/dashboard/order-details",
          {
            orderId: order.id,
          },
          {
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this.selectedOrderId = order.id;
            this.currentOrder = response.data.order;
            // console.log(this.currentOrder);
          } else {
            this.loading = false;
            this.error = response.data.message;
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.loading = false;
            this.error = err;
          }
        });
    },
    handleSelectProduct: function (product) {
      this.currentProduct = product;
    },
    toggleSizeUpdate: function () {
      axios
        .post(
          `${herokuUrl}/dashboard/getAllUserMeasurements`,
          {
            userId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.success) {
            this.profiles = response.data.measurementData;
            this.sizesUpdate = true;
          } else {
            this.loading = false;
            this.error = response.data.message;
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.loading = false;
            this.error = err;
          }
        });
    },
    applySizeUpdate: function () {
      axios
        .put(
          `${herokuUrl}/dashboard/edit-product-measurement`,
          {
            orderProductId: this.currentProduct.orderProductId,
            measurement:
              this.measurementToUpdate.type == "profile"
                ? this.measurementToUpdate.size.id
                : this.measurementToUpdate.type == "static"
                ? this.measurementToUpdate.size
                : this.measurementToUpdate,
            measurementType:
              this.measurementToUpdate.type == "profile"
                ? "profile"
                : this.measurementToUpdate.type == "static"
                ? "static"
                : "shoes",
          },
          {
            headers: {
              Authorization: getCookie("user"),
              "Content-Type": "Application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            if (this.measurementToUpdate.type == "static") {
              this.currentProduct.size = this.measurementToUpdate.size;
              this.currentProduct.profile = null;
              this.sizesUpdate = false;
            } else if (this.measurementToUpdate.type == "profile") {
              this.currentProduct.size = null;
              this.currentProduct.profile = this.measurementToUpdate.size;
              this.sizesUpdate = false;
            } else if (this.measurementToUpdate) {
              this.currentProduct.size = this.measurementToUpdate;
              this.currentProduct.profile = null;
              this.sizesUpdate = false;
            }
          } else {
            this.loading = false;
            this.error = response.data.message;
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.loading = false;
            this.error = err;
          }
        });
    },
    /**
     * Get modified Order Status text instead of API Status
     * @param  {string} apiStatus Order Status from API (i.e. "pending_payment")
     * @return {string} Modified Order Status according to "orderStatuses" array of objects
     */
    getOrderStatusText(apiStatus) {
      let result = this.orderStatuses.filter((status) => {
        return status.value == apiStatus;
      });
      return result[0].text;
    },
  },
  created() {
    this.loading = true;
    Promise.all([
      axios.post(
        herokuUrl + "/dashboard/getAllOrders",
        {
          userId: this.$route.params.id,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
        {
          headers: {
            Authorization: getCookie("user"),
            "Content-Type": "Application/json",
          },
        }
      ),
      axios.post(
        herokuUrl + "/dashboard/getAllUserData",
        {
          id: this.$route.params.id,
        },
        {
          headers: {
            Authorization: getCookie("user"),
            "Content-Type": "Application/json",
          },
        }
      ),
    ])
      .then((results) => {
        let ordersResponse = results[0];
        this.userData = results[1].data.user;
        if (ordersResponse.data.status) {
          this.loading = false;
          this.orders = ordersResponse.data.orders;
          if (this.$route.params.orderId) {
            this.handleSelectOrder({ id: this.$route.params.orderId });
          }
        } else {
          this.loading = false;
          this.error = ordersResponse.data.message;
        }
      })
      .catch((err) => {
        this.loading = false;
        this.error = err;
      });
  },
};
</script>

<style lang="scss" scoped>
#grand-container {
  max-width: 85%;
  min-width: 85%;
  padding: 0;
  // overflow-x: scroll;
}

h3 {
  margin: 1.5rem;
}

.orders {
  width: 100%;
  overflow-x: scroll;
}
.selectedOption {
  border: mediumpurple;
  border-width: 5px;
  border-style: solid;
}

::-webkit-scrollbar {
  width: 0px;
  height: 5px;
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: darkgray;
}
.order,
.order--row {
  display: flex;
  margin-bottom: 5px;
  justify-content: space-between;
  align-items: center;
  &__attribute {
    margin: 0;
    min-width: 120px;
    max-width: 120px;
    text-align: center;
    overflow-x: scroll;
    margin-right: 10px;
    font-size: 14px !important;
    font-weight: bold;
  }
}
.order {
  background-color: #ccc;
  width: fit-content;
}
.order--row {
  border-radius: 10px;
  width: fit-content;
  &:nth-child(odd) {
    background-color: #fff;
  }
  cursor: pointer;
  &:hover {
    background-color: #ccc;
  }
}
.nav-buttons {
  display: flex;
  justify-content: space-around;
  align-items: center;
  p {
    vertical-align: middle;
    margin: 0;
  }
}
.current-order {
  &__details {
    text-align: left;
  }
}
.product {
  &__header,
  &__row {
    display: flex;
    margin-bottom: 5px;
    justify-content: space-between;
    align-items: center;

    &__attribute {
      margin: 0;
      width: 10%;
      text-align: center;
      overflow-x: scroll;
    }
  }
  &__row {
    border-radius: 10px;
    &:nth-child(odd) {
      background-color: #fff;
    }
    cursor: pointer;
    &:hover {
      background-color: #ccc;
    }
  }
  &__cell {
    width: 10%;
    overflow-x: scroll;
  }
}
.current-order__products {
  .product__cell {
    margin-bottom: 0;
  }
}
option:disabled {
  color: #bbbbbb;
}
</style>
